import styled from "@emotion/styled";
export const StyledBenefit = styled.div`
  display: flex;
  font-size: 0.875rem;
  line-height: 24px;

  &.align-center {
    flex-direction: column;
    align-items: center;

    .benefit-content {
      text-align: center;
    }

    .benefit-icon-wrapper {
      color: red;

      .benefit-icon {
        width: 24px;
        height: 24px;
      }
    }
  }

  .benefit-icon-wrapper {
    margin-top: 2px;
  }

  .benefit-content {
    flex-grow: 1;
    margin-left: 8px;

    .benefit-title {
      font-weight: 700;
    }

    .benefit-description {
    }
  }
`;
